import { sortString, sortNumber, toSearchableString } from 'app/utils';

const TEMPLATE_NAME = 'PROFESSIONALS';

const sort = function (a, b) {
    let result = sortNumber(a.status, b.status);
    if (result !== 0) {
        return result;
    }
    const aName = a.name || null;
    const bName = b.name || null;
    result = sortString(aName, bName);
    if (result !== 0) {
        return result;
    }
    return sortString(a.key, b.key);
};

const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));

const filterData = (data, term) => {
    const result = data.filter(item => {
        const nurseName = item.name ? filterByTerm(item.name, term) : false;
        const nurseCPF = item.cpf ? filterByTerm(item.cpf, term) : false;
        return nurseCPF || nurseName;
    });
    if (sort) {
        result.sort(sort);
    }
    return result;
};

const initialState = () => ({
    loading: false,
    data: [],
    filter: {
        term: '',
        data: [],
    },
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${TEMPLATE_NAME}_FULFILLED`: {
            const currentData = state.data;
            const newData = action.payload;
            console.log(newData)
            return {
                ...state,
                loading: false,
                // data: data,
                data: [...currentData, ...newData],
                filter: {
                    ...state.filter,
                    // data: filterData(data, state.filter.term),
                    data: [...state.data, ...newData],
                },
            };
        }
        case `${TEMPLATE_NAME}_SEARCH_PENDING`: {
            return {
              ...state,
              loading: true,
            };
          }
          case `${TEMPLATE_NAME}_SEARCH_REJECTED`: {
            return {
              ...state,
              loading: false,
            };
          }
          case `${TEMPLATE_NAME}_SEARCH_FULFILLED`: {
            const { data, searchTerm } = action.payload;
            return {
              ...state,
              loading: false,
              filter: {
                ...state.filter,
                data: searchTerm ? data : state.data,
              },
            };
          }
        case `${TEMPLATE_NAME}_UPDATE`: {
            const updatedRow = action.payload;
            const data = state.data.map(row => (row.id === updatedRow.id ? updatedRow : row));
            return {
                ...state,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term),
                },
            };
        }
        case `${TEMPLATE_NAME}_DELETE`: {
            const deletedId = action.payload;
            const data = state.data.filter(data => data.idCliente !== deletedId);
            
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_CREATE`: {
            const newRow = action.payload;
            const data = [...state.data, newRow];
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};
export default reducer;
